webpackJsonp([101255138922551],{

/***/ 3057:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/checklist_bottom.2386edcf.jpg";

/***/ }),

/***/ 3058:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/checklist_logo.dca18456.png";

/***/ }),

/***/ 1659:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _siteConfig = __webpack_require__(7);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _Container = __webpack_require__(5);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Formchecklist = __webpack_require__(1171);
	
	var _Formchecklist2 = _interopRequireDefault(_Formchecklist);
	
	var _SEO = __webpack_require__(6);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _checklist_logo = __webpack_require__(3058);
	
	var _checklist_logo2 = _interopRequireDefault(_checklist_logo);
	
	var _checklist_bottom = __webpack_require__(3057);
	
	var _checklist_bottom2 = _interopRequireDefault(_checklist_bottom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Brokeragetechchecklist = function Brokeragetechchecklist(_ref) {
	  var children = _ref.children,
	      classes = _ref.classes,
	      data = _ref.data,
	      tags = _ref.tags;
	
	  var postNode = {
	    title: "Brokerage Technology Checklist - " + _siteConfig2.default.siteTitle
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: classes.root },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        "title",
	        null,
	        "Brokerage Technology Checklist - " + _siteConfig2.default.siteTitle
	      )
	    ),
	    _react2.default.createElement(_SEO2.default, { postNode: postNode, pagePath: "Brokerage Technology Checklist", customTitle: true }),
	    _react2.default.createElement(
	      _Container2.default,
	      null,
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { style: { maxWidth: "900px", backgroundColor: "#f7f7f7", marginRight: "auto", marginLeft: "auto", paddingTop: "35px", textAlign: "center" } },
	          _react2.default.createElement(
	            "div",
	            { style: { paddingLeft: "65px", paddingRight: "65px" } },
	            _react2.default.createElement("img", { src: _checklist_logo2.default, width: "100%", style: { paddingBottom: "25px", paddingTop: "20px", maxWidth: "450px", textAlign: "center" } }),
	            _react2.default.createElement(
	              "h1",
	              { className: classes.Heading },
	              "Brokerage Technology Checklist",
	              _react2.default.createElement("br", null),
	              "FREE DOWNLOAD"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { color: "#495050", lineHeight: "26px", textAlign: "center", paddingBottom: "30px" } },
	              "Download your comprehensive guide to selecting the right technology partner for your brokerage. Includes the top 4 questions to ask tech companies to separate potential partners from vendors, and a checklist of features & functionality every brokerage must have!"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { paddingLeft: "30px", paddingRight: "30px", paddingBottom: "20px" } },
	            _react2.default.createElement(_Formchecklist2.default, null)
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement("img", { src: _checklist_bottom2.default, style: { width: "100%" } })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  var _ref2;
	
	  return _ref2 = {
	    root: {
	      display: "flex",
	      flexDirection: "column",
	      width: "100%",
	      padding: "0 8px",
	      marginLeft: "auto",
	      marginRight: "auto",
	      marginTop: "0px",
	      marginBottom: "70px"
	    },
	
	    Heading: {
	      fontSize: "28px",
	      fontWeight: "700",
	      lineHeight: "36px",
	      letterSpacing: ".14px",
	      color: "#55c3ba",
	      textAlign: "center",
	      marginBottom: "18px"
	    },
	
	    subHeading: {
	      fontSize: "18px",
	      lineHeight: "28px",
	      fontWeight: "600",
	      letterSpacing: ".08px",
	      color: "#888f96",
	      textAlign: "center",
	      margin: "0 auto 36px"
	    }
	
	  }, _ref2["subHeading"] = {
	    fontSize: "18px",
	    lineHeight: "28px",
	    letterSpacing: ".08px",
	    textAlign: "center",
	    margin: "0 auto 36px"
	  }, _ref2.landingHeaderStyle = {
	    textAlign: "center",
	    marginBottom: "30px"
	  }, _ref2;
	})(Brokeragetechchecklist);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-brokeragetechchecklist-js-f6246a29ba92f4ecdf45.js